import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

const textPrimary = (theme) => ({
  color: theme.palette.text.primary,
  fontFamily: "'Quicksand', sans-serif",
});

export const RootBox = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const ContentWrapper = styled(Box)(({ theme }) => ({
  textAlign: "center",
  marginTop: theme.spacing(2.5),
  width: "100%",
}));

export const Image = styled("img")(({ theme }) => ({
  display: "block",
  maxWidth: "100%",
  height: "auto",
  borderRadius: theme.spacing(2),
}));

export const BodyTypography = styled(Typography)(({ theme }) => ({
  ...textPrimary(theme),
  fontSize: "18px",
  marginTop: theme.spacing(2.5),
  textAlign: "left",
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(1.75),
  },
}));

export const CardBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(3),
  backgroundColor: "rgba(41, 64, 90, 0.08)",
  borderRadius: "16px",
  textAlign: "center",
}));

export const CardTitleTypography = styled(Typography)(({ theme }) => ({
  ...textPrimary(theme),
  fontSize: "20px",
  fontWeight: 600,
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(2),
  },
}));

export const CardDateTimeTypography = styled(Typography)(({ theme }) => ({
  color: "#29405A",
  fontSize: "24px",
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: 700,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down("md")]: {
    fontSize: "22px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
  },
}));

export const JoinButtonWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
}));
